import translate from '@translate';
import React, { FC, useEffect } from 'react';
import { Typography } from '@mui/material';
import Grid, { GridItem } from 'src/components/Grid';
import DateTimePicker from 'src/components/DateTimePicker';
import { DateType } from 'src/types/date';

export interface ReleaseFromSuspendedConfirmDataType {
    value?: DateType;
    disabled?: boolean;
}

export interface ReleaseFromSuspendedConfirmPropsType {
    data: ReleaseFromSuspendedConfirmDataType;
    setData: (data: ReleaseFromSuspendedConfirmDataType) => void;
    initialValue?: DateType;
}

const ReleaseFromSuspendedConfirm: FC<ReleaseFromSuspendedConfirmPropsType> = (props) => {
    useEffect(() => {
        props.setData({ value: props.initialValue ?? null, disabled: false });
    }, []);

    const value: DateType = 'value' in props.data ? props.data.value ?? null : props.initialValue ?? null;

    return (
        <Grid>
            <GridItem cols={12}>
                <Typography gutterBottom>{translate('orderDetail.confirmReleaseFromSuspendedAtText')}</Typography>
            </GridItem>
            <GridItem cols={12}>
                <DateTimePicker
                    value={value}
                    error={props.data.disabled}
                    onChange={(newValue, error) =>
                        props.setData({ value: (newValue as DateType) ?? null, disabled: error })
                    }
                    name="RELEASE_FROM_SUSPENDED_AT"
                    label={translate('orderDetail.releaseFromSuspendedAt')}
                    fullWidth
                    disablePast
                    type="dateTime"
                />
            </GridItem>
        </Grid>
    );
};

export default ReleaseFromSuspendedConfirm;
